
import { defineComponent } from "vue"
import store from "../../services/store/"
import ServerCard from "../../components/ServerCard.vue"
import AddInstance from "../../components/AddInstance.vue"

export default defineComponent({
  data: () => ({
    createInstance: false
  }),
  computed: {
    instances: () => store.state.instances.instances
  },
  components: {
    ServerCard,
    AddInstance
  }
})
